import { render, staticRenderFns } from "./ServiceRequirement.vue?vue&type=template&id=4d5e097e&"
import script from "./ServiceRequirement.vue?vue&type=script&lang=js&"
export * from "./ServiceRequirement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports